import axiosInstance from "../lib/axiosInstance";


const Baseurl = process.env.REACT_APP_API_URL


const userModel = class {

    async Edit(form) {
        return await axiosInstance.put(Baseurl +`/users/update/profile`,form);
    }
    async Get(id) {
        return await axiosInstance.get(Baseurl +`/users/get/profile`);
    }
}

export default new userModel();